import { useFieldContext } from '../FieldContext';
import { EmptyValue } from './EmptyValue';

/**
 * TWO SHAPES, and `multiline` plus `dense` decide which (`inbound-intake.md` D18).
 *
 * A one-line TEXT field renders identically everywhere, which is why this component had no
 * branch until now. A MULTILINE one cannot: the intake document is "Title" lines followed by
 * "question: answer" lines, and the record page has to keep those breaks or hand a coach one
 * unreadable paragraph - while a 54px table row has no way to show them at all.
 *
 *  - MULTILINE, FULL (the record page): `whitespace-pre-wrap`, so every line break and blank
 *    line the writer put in survives, with `break-words` for the URL somebody pasted.
 *  - Everywhere else: ONE clamped line. `truncate` sets `white-space: nowrap`, which folds
 *    the breaks into spaces, so a multiline value in a cell reads as the first line of the
 *    document with an ellipsis rather than as a row that grew.
 *
 * `dense` is the FieldContext flag `displayContext` already sets, and only it does
 * (`file-attachments.md` D18 introduced it for the same table-row-versus-page split). Reusing
 * it rather than adding a second flag is what keeps the table, the related rows, the record
 * cards and the dashboard panels - the four surfaces that render a row - agreeing about what
 * a row is.
 */
export function TextDisplay() {
  const { field, value, dense } = useFieldContext();
  if (typeof value !== 'string' || value.length === 0) {
    return <EmptyValue />;
  }
  if (field.options?.multiline === true && dense !== true) {
    return <span className="block whitespace-pre-wrap break-words">{value}</span>;
  }
  return <span className="block truncate">{value}</span>;
}
